import thumbnailImg from 'Static/thumbnails/screenshot--mammals.png';

export default {
  slug: 'mammals',
  title: 'Mammals',
  seriesNumber: '9',
  published: true,
  thumbnailImg,
  subject: 'Life Sciences',
  graphicFileName: 'Image_Mammals.png',
  graphicAlt:
    'App screenshot of Mammals depicting the reproductive system of an elephant',
  iconFileName: 'Icon_Mammals.png',
  iconLargeFileName: 'Icon_Mammals@2x.png',
  iconAlt: 'App icon for Mammals depicting the skeletal system of an elephant',
  description:
    'Topics covered include biology, anatomy, senses, mammals, vertebrates, and adaptations.',
  briefDescription: 'Learn about biology, anatomy & more.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bn',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fa',
    'fi',
    'fr',
    'he',
    'hi',
    'ht',
    'hu',
    'id',
    'is',
    'it',
    'ja',
    'ko',
    'ms',
    'nb',
    'nl',
    'pa',
    'pl',
    'pt',
    'ro',
    'ru',
    'sr',
    'sv',
    'ta',
    'th',
    'tl',
    'tr',
    'uk',
    'ur',
    'uz',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'LandingScene',
    'Comparison_Locomotion',
    'Vision_Human',
    'Vision_Sloth',
    'Vision_Bat',
    'Vision_Elephant',
    'Vision_Tiger',
    'Vision_Kangaroo',
    'Comparison_Fur',
    'Fur_Sloth',
    'Fur_Bat',
    'Fur_Elephant',
    'Fur_Tiger',
    'Fur_Kangaroo',
    'Bat_Exterior',
    'Scene_Bat_Echolocation_POI',
    'Bat_Muscles',
    'Bat_Circulatory',
    'Bat_Digestion',
    'Bat_Nervous',
    'Bat_Skeletal',
    'Sloth_Exterior',
    'Scene_Sloth_EatingPOI',
    'Scene_Sloth_Moths_POI',
    'Sloth_Muscles',
    'Sloth_Circulatory',
    'Sloth_Digestion',
    'Sloth_Nervous',
    'Sloth_Skeletal',
    'Elephant_Exterior',
    'Scene_Elephant_Trunk_POI',
    'Scene_Elephant_Birth_POI',
    'Elephant_Muscles',
    'Elephant_Circulatory',
    'Elephant_Digestion',
    'Elephant_Nervous',
    'Elephant_Skeletal',
    'Elephant_Urogenital',
    'Tiger_Exterior',
    'Scene_Tiger_Whiskers_POI',
    'Scene_Tiger_Claws_POI',
    'Slider_Open_Scene_Tiger_Whiskers_POI',
    'Tiger_Muscles',
    'Tiger_Circulatory',
    'Tiger_Digestion',
    'Tiger_Nervous',
    'Tiger_Skeletal',
    'Kangaroo_Exterior',
    'Scene_Kangaroo_Crawl_POI',
    'Scene_Kangaroo_Nursing_POI',
    'Kangaroo_Muscles',
    'Kangaroo_Circulatory',
    'Kangaroo_Digestion',
    'Kangaroo_Urogenital',
    'Kangaroo_Nervous',
    'Kangaroo_Skeletal',
  ],
  featuredPrintables: ['mammals_animal_diets'],
  printables: ['mammals_body_systems', 'concept_map', 'generating_questions'],
  topics: [
    'animal_adaptations',
    'sensory_detection',
    'animal_diets',
    'animal_parts_and_engineering',
    'internal_systems',
  ],
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/mammals-by-tinybop/id1193715162',
  },
};
